import { streamRequest, StreamOptions } from '../http/sseClient'

export type ReceivedDate = {
  codigoDataRecebimentoId: number
  descricao: string
}

export async function getReceivedDates(options?: StreamOptions) {
  const data = await streamRequest<ReceivedDate[]>({
    method: 'GET',
    path: '/crefisa/received-dates',
    ...options,
  })

  return data ?? []
}
